import { Dscauhoi } from './dscauhoi';
export class DscauhoiTraloi {
    id: number;
    cauhoiid: number;
    cautraloi: string;
    ghichu: string;
    sophieu: number;
    phantram: number;
    isactive: number;
    createddate: Date;
    createdbyuserid: number;
    modifiedbyuserid: number;
    modifieddate: Date;     
    dscauhoi: Dscauhoi;
  
   }